import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

export default async function () {
  const formStore = useFormStore()

  try {
    const res = await apiHelperService.post('/api/icaRequest/draft/submitApplication', {
      ...formStore.draft
    })
    if (res) {
      const {
        externalReferenceNumber = '',
        request: { pran = '', eidaPayment = '', requireEnrollmentInd = '' }
      } = res || {}
      formStore.draft.request = {
        ...formStore.draft.request,
        pran,
        eidaPayment,
        isNeedFingerPrint: requireEnrollmentInd,
        requireEnrollmentInd,
        externalReferenceNumber
      }
    }
    return true
  } catch (error) {
    console.error('Error submitting application: user561PreReview', error)
  }
}
